import { environment } from '@/app/environments/environment';
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { NgHttpService } from './auth/httpservice';

@Injectable()
export class SharedService {
  constructor(private _http: NgHttpService) { }

  buscarListaCampoAdicional(params: any = {}): Observable<any> {
    return this._http.post(environment.apiGeral, `CamposAdicionais/BuscarLista`, params)
  }

  listarClientes(): Observable<any> {
    return this._http.get(environment.apiAcessoExterno, `AcessoExterno/ListarClientesAcessoExterno`, {});
  }

  baixarArquivo(url: string): Observable<any> {
    return this._http.get(environment.apiTerminal, `Documento`, {url: url});
  }

  carregarEntidade(entidadeId: any): Observable<any> {
    return this._http.get(environment.apiAcessoExterno, `AcessoExterno/CarregarEntidade`, { entidadeId: entidadeId });
  }

  listarCategoriasOperacao(clienteId: any): Observable<any> {
    return this._http.get(environment.apiAcessoExterno, `ContainerProgramacaoAcessoExterno/ListarCategoriasOperacao`, { clienteId: clienteId });
  } 

  listarEnderecoCliente(params: any): Observable<any> {
    return this._http.get(environment.apiAcessoExterno, `AcessoExterno/ListarEnderecoCliente`, params);
  }

  listarTiposContainer(clienteId: any): Observable<any> {
    return this._http.get(environment.apiAcessoExterno, `AcessoExterno/ListarTipoContainerAcessoExterno`, { terminalId: clienteId });
  }

  listarLocalizacoes(): Observable<any> {
    return this._http.get(environment.apiAcessoExterno, `LocalizacaoAcessoExterno/ListarEnderecos`, { });
  }

  carregarEntidadeFrete(): Observable<any> {
    return this._http.get(environment.apiAcessoExterno, `AcessoExterno/BuscarEntidade`, { });
  }

  listarEnderecos(params: any): Observable<any> {
    return this._http.get(environment.apiAcessoExterno, `LocalizacaoAcessoExterno/ListarEnderecos`, params);
  }

  getVeiculo(params: any): Observable<any> {
    return this._http.get(environment.apiAcessoExterno, `VeiculoAcessoExterno`, params);
  }

  getMotorista(params: any): Observable<any> {
    return this._http.get(environment.apiAcessoExterno, `MotoristaAcessoExterno/Buscar`, params);
  }
}
